// Auto-generated by scripts/generate-registry.mjs from packages/modules/essential_oil_tray/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const essential_oil_tray: ModuleSchema = {
  "id": "essential_oil_tray",
  "uniqueId": "B3D_EO10M",
  "createdAt": "2026-10-09T14:41:52.913Z",
  "updatedAt": "2026-10-10T14:34:20.420Z",
  "label": "Essential Oil Tray",
  "description": "Rounded grid tray for Plant Therapy 10 ml and 30 ml essential-oil bottles.",
  "category": "gadgets",
  "tags": [
    "essential-oil",
    "Plant Therapy",
    "10ml",
    "30ml",
    "organizer",
    "core-grid-hole-tray"
  ],
  "sliders": [
    {
      "key": "height",
      "label": "Tray Height",
      "min": 20,
      "max": 80,
      "step": 1,
      "default": 42,
      "unit": "mm"
    },
    {
      "key": "columns10",
      "label": "10 ml Bottles per Row",
      "min": 1,
      "max": 16,
      "step": 1,
      "default": 5
    },
    {
      "key": "rows10",
      "label": "10 ml Rows",
      "min": 0,
      "max": 12,
      "step": 1,
      "default": 3
    },
    {
      "key": "columns30",
      "label": "30 ml Bottles per Row",
      "min": 1,
      "max": 16,
      "step": 1,
      "default": 5
    },
    {
      "key": "rows30",
      "label": "30 ml Rows",
      "min": 0,
      "max": 12,
      "step": 1,
      "default": 1
    },
    {
      "key": "diameter10",
      "label": "10 ml Bottle Diameter",
      "min": 24,
      "max": 30,
      "step": 0.1,
      "default": 26,
      "unit": "mm"
    },
    {
      "key": "diameter30",
      "label": "30 ml Bottle Diameter",
      "min": 30,
      "max": 36,
      "step": 0.1,
      "default": 32.5,
      "unit": "mm"
    },
    {
      "key": "fitClearance",
      "label": "Hole Diametral Clearance",
      "min": 0,
      "max": 2,
      "step": 0.1,
      "default": 0.6,
      "unit": "mm"
    },
    {
      "key": "pitchX",
      "label": "Gap Between Bottles Across Row",
      "min": 0,
      "max": 12,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "pitchY",
      "label": "Gap Between Bottle Rows",
      "min": 0,
      "max": 12,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "edgeMargin",
      "label": "Outer Margin Around Bottles",
      "min": 3,
      "max": 25,
      "step": 0.5,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "penSlotWidth",
      "label": "Horizontal Pen Slot Length",
      "min": 40,
      "max": 200,
      "step": 1,
      "default": 140,
      "unit": "mm"
    },
    {
      "key": "penSlotBreadth",
      "label": "Horizontal Pen Slot Width",
      "min": 8,
      "max": 18,
      "step": 1,
      "default": 12,
      "unit": "mm"
    },
    {
      "key": "wallThickness",
      "label": "Outer Wall Thickness",
      "min": 1.2,
      "max": 10,
      "step": 0.2,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "floorThickness",
      "label": "Bottom Thickness",
      "min": 1.2,
      "max": 10,
      "step": 0.2,
      "default": 3,
      "unit": "mm"
    },
    {
      "key": "holeMouthRound",
      "label": "Hole Mouth Roundover",
      "min": 0,
      "max": 2,
      "step": 0.1,
      "default": 0.6,
      "unit": "mm"
    },
    {
      "key": "sideRibSpacing",
      "label": "Groove Spacing",
      "min": 2,
      "max": 12,
      "step": 0.5,
      "default": 6,
      "unit": "mm"
    },
    {
      "key": "sideRibWidth",
      "label": "Groove Width",
      "min": 0.5,
      "max": 4,
      "step": 0.1,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "sideRibDepth",
      "label": "Recessed Groove Depth (0 disables)",
      "min": 0,
      "max": 3,
      "step": 0.1,
      "default": 1,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "tray",
      "label": "Tray",
      "default": "#9E9E9E",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "essential_oil_tray_obj",
      "label": "Essential Oil Bottle Tray",
      "name": "Essential Oil Bottle Tray",
      "color": "#9E9E9E",
      "parts": [
        {
          "id": "essential_oil_tray",
          "label": "Bottle Tray",
          "name": "Bottle Tray",
          "groupId": 0,
          "colorKey": "tray",
          "defaultColor": "#9E9E9E",
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Complete Essential Oil Tray",
      "targetGroupId": -1,
      "default": true
    }
  ]
};
